import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL || "http://localhost:8010";

const getAuthToken = () => {
  return localStorage.getItem('authToken');
};

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const subUserAPI = {
  // Owner-only management
  list: async () => {
    try {
      const response = await api.get('/sub-users/');
      return response.data;
    } catch (error) {
      console.error('Error listing sub-users:', error);
      throw error;
    }
  },

  get: async (subUserId) => {
    try {
      const response = await api.get(`/sub-users/${subUserId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching sub-user:', error);
      throw error;
    }
  },

  create: async ({ email, password, displayName, preset }) => {
    try {
      const response = await api.post('/sub-users/', {
        email,
        password,
        display_name: displayName,
        preset: preset || null,
      });
      return response.data;
    } catch (error) {
      console.error('Error creating sub-user:', error);
      throw error;
    }
  },

  update: async (subUserId, { displayName }) => {
    try {
      const response = await api.put(`/sub-users/${subUserId}`, {
        display_name: displayName,
      });
      return response.data;
    } catch (error) {
      console.error('Error updating sub-user:', error);
      throw error;
    }
  },

  deactivate: async (subUserId) => {
    try {
      const response = await api.patch(`/sub-users/${subUserId}/deactivate`);
      return response.data;
    } catch (error) {
      console.error('Error deactivating sub-user:', error);
      throw error;
    }
  },

  reactivate: async (subUserId) => {
    try {
      const response = await api.patch(`/sub-users/${subUserId}/reactivate`);
      return response.data;
    } catch (error) {
      console.error('Error reactivating sub-user:', error);
      throw error;
    }
  },

  resetPassword: async (subUserId, newPassword) => {
    try {
      const response = await api.post(`/sub-users/${subUserId}/reset-password`, {
        new_password: newPassword,
      });
      return response.data;
    } catch (error) {
      console.error('Error resetting sub-user password:', error);
      throw error;
    }
  },

  reset2FA: async (subUserId) => {
    try {
      const response = await api.post(`/sub-users/${subUserId}/reset-2fa`);
      return response.data;
    } catch (error) {
      console.error('Error resetting sub-user 2FA:', error);
      throw error;
    }
  },

  updatePermissions: async (subUserId, { preset, overrides }) => {
    try {
      const response = await api.put(`/sub-users/${subUserId}/permissions`, {
        preset: preset || null,
        overrides: overrides || {},
      });
      return response.data;
    } catch (error) {
      console.error('Error updating sub-user permissions:', error);
      throw error;
    }
  },

  getLimit: async () => {
    try {
      const response = await api.get('/sub-users/limit');
      return response.data;
    } catch (error) {
      console.error('Error fetching sub-user limit:', error);
      throw error;
    }
  },

  getPermissionRegistry: async () => {
    try {
      const response = await api.get('/sub-users/permission-registry');
      return response.data;
    } catch (error) {
      console.error('Error fetching permission registry:', error);
      throw error;
    }
  },

  // Available to any logged-in actor (owner or sub-user) — "what can I do"
  getMyPermissions: async () => {
    try {
      const response = await api.get('/sub-users/me/permissions');
      return response.data;
    } catch (error) {
      console.error('Error fetching my permissions:', error);
      throw error;
    }
  },
};
